export default __webpack_public_path__ + "static/media/0000..0001.dc0a7a38.png";